import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Select, Table, Tag, Card, Typography } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Option } = Select;
const { Title } = Typography;

const UsersReport = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const { token } = useAuth();

  const fetchUsers = async (status) => {
    setLoading(true);
    try {
      const params = {};
      if (status && status !== 'all') {
        params.status = status;
      }
      const response = await api.get('/api/users', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Failed to fetch users', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUsers(statusFilter);
    }
  }, [token, statusFilter]);

  const columns = [
    { title: 'اسم المستخدم', dataIndex: 'username', key: 'username' },
    { title: 'البريد الإلكتروني', dataIndex: 'email', key: 'email' },
    { title: 'الدور', dataIndex: 'role', key: 'role' },
    {
      title: 'الحالة',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>{status === 'active' ? 'نشط' : 'غير نشط'}</Tag>
      ),
    },
    {
      title: 'تاريخ التسجيل',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => new Date(date).toLocaleDateString('ar-SA'),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={3}>تقرير المستخدمين</Title>
        <PrintButton />
      </div>
      <Card title="تقرير المستخدمين">
        <div className="no-print">
          <Select
            defaultValue="all"
            style={{ width: 150, marginBottom: 16 }}
            onChange={(value) => setStatusFilter(value)}
          >
            <Option value="all">كل الحالات</Option>
            <Option value="active">نشط</Option>
            <Option value="inactive">غير نشط</Option>
          </Select>
          <Table
            dataSource={users}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </Card>
    </div>
  );
};

export default UsersReport;